const state = {
  currentTab: 'homePage',
  tabsPath: [],
  tabList: [],
  keepAliveList: [],
  openIframeList: [],
  userPage: ''
}
const getters = {
  tabLists (state) {
    return state.tabList
  },
  keepAliveLists (state) {
    return state.keepAliveList
  },
  openIframeLists (state) {
    return state.openIframeList
  },
  getCurrentTab () {
    return state.currentTab
  },
  getTabsPath () {
    return state.tabsPath
  },
  userHomePage () {
    return state.userPage
  }
}
const mutations = {
  setPage (state, tab) {
    state.userPage = tab
  },
  setTabList (state, tab) {
    state.tabList.push(tab)
  },
  removeTabList (state, targetName) {
    state.tabList = state.tabList.filter(tab => tab.name !== targetName)
  },
  setOpenIframeList (state, vueName) {
    state.openIframeLists.push(vueName)
  },
  setKeepAliveList (state, vueName) {
    state.keepAliveList.push(vueName)
  },
  removeKeepAliveList (state, vueName) {
    state.keepAliveList = state.keepAliveList.filter(item => item !== vueName)
  },
  setCurrentTab (state, newTabName) {
    state.currentTab = newTabName
  },
  setTabsPath (state, tabPath) {
    state.tabsPath.push(tabPath)
  },
  removeTabsPath (state, targetName) {
    state.tabsPath = state.tabsPath.filter(tab => tab.name !== targetName)
  },
  clearTabsPath (state) {
    state.tabsPath = []
  },
  clearTabList (state) {
    state.tabList = []
  }
}
const actions = {

}
export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
}
